var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 12,
    viewBox: "0 0 27 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1192 1.22498C16.4599 1.22622 19.686 2.48807 22.1953 4.77499L27 0V12H15.0961L19.8639 7.19998C18.5559 6.05728 16.9993 5.26208 15.3285 4.88307C13.6577 4.50407 11.9231 4.55268 10.2745 5.02471C8.62587 5.49674 7.11292 6.37798 5.86637 7.59227C4.61983 8.80656 3.67718 10.3174 3.11993 11.9941L0 11.0691C0.913065 8.20763 2.67166 5.71684 5.02641 3.94992C7.38117 2.183 10.2126 1.22962 13.1192 1.22498Z",
    fill: "#2760A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallback);
export default __webpack_public_path__ + "static/media/callback.55ad5d38debc06d71773e8ebb0c92917.svg";
export { ForwardRef as ReactComponent };